import { get } from 'lodash';

export const transformToRecord = <U>(array: Array<U>, key = 'id') =>
  array.reduce<Record<string, U>>(
    (acc, item) => ({ ...acc, [get(item, key)]: item }),
    {},
  );
